<template>
  <div>
    <!-- 中国国内物流 -->
    <baseBreadcrumb :page="$t('message.chineseDomesticLogistics')" :menu="$t('message.orderManagement')">
    </baseBreadcrumb>
    <div class="body">
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="statusRange" type="card" @tab-click="search">
          <el-tab-pane :label="item.name + `(${item.count})`" :name="item.statusRange" v-for="(item, index) in tabs"
            :key="index">
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 注文書番号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" placeholder="注文書番号" clearable onfocus="this.select()"></el-input>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 画像 -->
          <li>画像</li>
          <!-- 商品情報 -->
          <li>商品情報</li>
          <!-- 購入数量 -->
          <li>購入数量</li>
          <!-- 単価.元 -->
          <li>単価.元</li>
          <!-- 小計.元 -->
          <li>小計.元</li>
          <!-- 国内運賃 -->
          <li>国内運賃</li>
          <!-- 備考欄 -->
          <li>備考欄</li>
          <!-- 状態 -->
          <li>状態</li>
        </ol>
        <!-- 暂无数据 -->
        <div v-if="list == false" class="No_data">暂无数据</div>
        <div v-if="show">
          <div class="detail" v-for="(item, index) in list" :key="index">
            <div class="item">
              <div class="order">注文番号： <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link"
                  target="_blank">{{ item.order_sn }}</router-link> <i class="el-icon-copy-document"
                  @click="copy(item.order_sn)"></i></div>
              <div class="li">{{ item.numTotal.toFixed(2) }}</div>
              <div class="li">{{ item.priceTotal.toFixed(2) }}</div>
              <div class="li">{{ item.total.toFixed(2) }}</div>
              <div class="li">{{ item.freightTotal.toFixed(2) }}</div>
              <div class="li"></div>
              <div class="li">
                <el-button v-if="!item.show" @click="item.show = !item.show">展開</el-button>
                <el-button v-else @click="item.show = !item.show">隠す</el-button>
              </div>
            </div>

            <ul v-for="(items, indexs) in item.order_detail" :key="indexs" v-show="item.show">
              <li class="flex05">
                <div>
                  {{ items.sorting }}
                  <!-- <router-link :to="'/pre-saleProblem?order_sn=' + item.order_sn" target="_blank"
                  v-if="items.problem_goods_status != null">
                  问
                </router-link>
               -->

                  <el-popover placement="top-end" width="350" trigger="hover">
                    <div v-for="(problem_goods) in items.problem_goods">
                      <p>问题提出时间：{{ problem_goods.created_at }}</p>
                      <p>问题类别：{{ problem_goods.type_name }}</p>
                      <p>具体问题描述：{{ problem_goods.description }}</p>
                    </div>
                    <router-link
                      :to="'/pre-saleProblem?order_sn=' + item.order_sn + '&status=' + items.problem_goods[items.problem_goods.length - 1].status"
                      target="_blank" v-if="items.problem_goods != false" slot="reference" class="wen">问
                    </router-link>
                  </el-popover>
                </div>
              </li>
              <!-- 画像 -->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="items.link" slot="reference" target="_blank">
                    <el-image :src="items.pic" style="width: 60px; height: 60px; border-radius: 4px">
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </a>
                </el-popover>
              </li>
              <!-- 商品情報 -->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom" style="height:100px">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 購入数量 -->
              <li>{{ items.confirm_num }}</li>
              <!-- 単価.元 -->
              <li>{{ items.confirm_price }}</li>
              <!-- 小計.元 -->
              <li>{{ items.total }}</li>
              <!-- 国内運賃 -->
              <li>{{ items.confirm_freight }}</li>
              <!-- 備考欄 -->
              <li>{{ items.client_remark }}</li>
              <!-- 状態 -->
              <li>{{ items.status_name }}</li>
            </ul>
          </div>
        </div>


      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      tabs: [],
      options: [],
      statusRange: "0,1,2,3,4,50,55,60",
      datas: {
        user_id: this.$route.query.userID,
        statusRange: [],
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        operation_id: "",
      },
      total: 0,
      list: [],

    };
  },
  created() {
    this.chinaLogisticsTabList();
    this.chinaLogisticsList();
  },
  methods: {
    chinaLogisticsTabList() {
      this.$api.clienteleApi.chinaLogisticsTabList(this.datas).then((res) => {
        res.data.forEach((item) => {
          item.statusRange = item.statusRange.join(",");
        });
        this.tabs = res.data;
      });
    },

    // 订单列表
    chinaLogisticsList() {
      if (this.statusRange) {
        this.datas.statusRange = this.statusRange.split(",");
      }
      this.show = false
      this.$api.clienteleApi.chinaLogisticsList(this.datas).then((res) => {
        this.show = true
        res.data.data.forEach(item => {
          item.show = true
          item.priceTotal = 0
          item.total = 0
          item.numTotal = 0
          item.freightTotal = 0
          item.order_detail.forEach(items => {
            item.numTotal += items.confirm_num - 0
            item.priceTotal += items.confirm_price - 0
            items.total = (items.confirm_price * items.confirm_num).toFixed(2)
            item.total += (items.total - 0)
            item.freightTotal += items.confirm_freight - 0
          })
        })
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },

    // 搜索
    search() {
      this.datas.page = 1;
      this.chinaLogisticsList();
    },
    // 重置
    reset() {
      this.statusRange = "0,1,2,3,4,5,55,60";
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        operation_id: "",
      };

      this.$forceUpdate();
      this.chinaLogisticsList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.chinaLogisticsList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.chinaLogisticsList();
    },

  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.body {
  position: relative;
}

.table {
  position: relative;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
  }

  .item {
    display: flex;
    padding: 20px 10px;
    background-color: #fff;

    .li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .order {
      flex: 2.5;
      display: flex;
      align-items: center;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: center;

    a {
      color: #fa5058;
      text-decoration: underline;
    }
  }

  .el-icon-sold-out {
    color: #fa5058;
    font-size: 40px;
    cursor: pointer;
  }

  .No_data {
    margin: 20px auto;
    text-align: center;
    font-size: 20px;
  }

  .attribute {
    width: 100%;
    text-align: left;
  }
}
</style>